/* MD Masala theme by Zoon Network · zoon.network
   Product page, computers: the arch grows (staying 4:5) until its bottom is level with the bottom of the buy box.
   The thumbnail track follows, because it is placed from --sw. */
(function () {
  var wide = window.matchMedia('(min-width: 900px)');
  var MIN_BUY = 380;
  var root, grid, buy, stage;
  function find() {
    root = document.querySelector('[data-pdp]');
    grid = root && root.querySelector('.mdpdp__grid');
    buy = root && root.querySelector('[data-pdp-buy]');
    stage = root && root.querySelector('.mdpdp__stage');
    return !!(grid && buy && stage);
  }
  if (!find()) return;

  function natural() {
    var was = buy.style.alignSelf;
    buy.style.alignSelf = 'start';
    var h = buy.getBoundingClientRect().height;
    buy.style.alignSelf = was;
    return h;
  }

  function fit() {
    grid.style.removeProperty('--sw');
    if (!wide.matches) return;
    var tcol = root.querySelector('.mdpdp__tcol');
    var side = (tcol ? tcol.getBoundingClientRect().width + 13 : 0) + (parseFloat(getComputedStyle(grid).columnGap) || 0);
    var max = grid.clientWidth - side - MIN_BUY;
    for (var i = 0; i < 4; i++) {
      var need = natural();
      var have = stage.getBoundingClientRect().height;
      if (Math.abs(need - have) < 1) break;
      if (need < have && !grid.style.getPropertyValue('--sw')) break;
      var sw = Math.min(stage.getBoundingClientRect().width * need / have, max);
      grid.style.setProperty('--sw', sw.toFixed(1) + 'px');
    }
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(fit, 120); }
  fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (wide.addEventListener) wide.addEventListener('change', fit);
  /* theme editor: the buy box is redrawn after an edit, so find the new one and fit again */
  document.addEventListener('shopify:section:load', function () { if (find()) fit(); });
})();
